export enum ETypeTable {
  Future = 'FUTURE',
  Past = 'PAST',
}
